<template>
  <PageWrapper :isLoading="isLoading" :hasFilters="true" :isExtended="true" @submitFilters="getMastersIncomeOutcome">
    <template #title> لیست حقوق و درآمد </template>
    <template #filters>
      <SearchInput inputId="userFullname" inputLabel="جستجو بر اساس نام استاد" inputPlaceholder="جستجوی نام..."
        v-model="mastersIncomeOutcomeFilters.fullName" @enter="getMastersIncomeOutcome"></SearchInput>
      <SearchInput inputId="userMobile" inputLabel="جستجو بر اساس شماره استاد" inputPlaceholder="0912..."
        v-model="mastersIncomeOutcomeFilters.mobile" @enter="getMastersIncomeOutcome"></SearchInput>
      <RangeDatePicker inputId="fromToDateRange" class="w-24 filters-width"
        label="بازه تاریخ درآمد استاد (بر اساس تاریخ ثبت کلاس)" @getDateRange="setFromToDateRange"></RangeDatePicker>
      <RangeDatePicker inputId="fromToScheduleDateRange" class="w-24 filters-width"
        label="بازه تاریخ درآمد استاد (بر اساس تاریخ شروع کلاس)" @getDateRange="setFromToScheduleDateRange">
      </RangeDatePicker>
      <PriceCategoryPicker @getPriceCategory="setPriceCategory" class="w-24 filters-width mr-md-2">
      </PriceCategoryPicker>
    </template>
    <template #extend>
      <BCol v-if="mastersIncomeOutcomeSum" cols="12">


        <div>
          <h3 style="padding-bottom: 12px;">کلاس گروهی</h3>
          <p v-if="mastersIncomeOutcomeSum">
            جمع <span class="text-success"> درآمد ناخالص کلاس گروهی </span> فرمن:‌
            <span class="text-success">
              {{
                mastersIncomeOutcomeSum.incomeGroupClass ?
                  Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeGroupClass) : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="text-danger"> حقوق استاد از کلاس گروهی </span>
            فرمن:
            <span class="text-danger">
              {{
                mastersIncomeOutcomeSum.outcomeGroupClass
                  ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.outcomeGroupClass)
                  : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="ferman-orange-text-color">
              سود کسب شده از کلاس گروهی
            </span>
            فرمن:
            <span v-if="mastersIncomeOutcomeSum" class="ferman-orange-text-color">
              {{
                Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeGroupClass -
                  mastersIncomeOutcomeSum.outcomeGroupClass)
              }}
            </span>
            تومان
          </p>

        </div>
        <hr>
        <div>
          <h3 style="padding-bottom: 12px;">کار در منزل</h3>
          <p>
            جمع <span class="text-success"> درآمد ناخالص کار در منزل </span> فرمن:‌
            <span class="text-success">
              {{
                mastersIncomeOutcomeSum.incomeHomeWork ?
                  Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeHomeWork) : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="text-danger"> حقوق استاد از کار در منزل </span>
            فرمن:
            <span class="text-danger">
              {{
                mastersIncomeOutcomeSum.outcomeHomeWork
                  ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.outcomeHomeWork)
                  : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="ferman-orange-text-color">
              سود کسب شده از کار در منزل
            </span>
            فرمن:
            <span class="ferman-orange-text-color">
              {{
                Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeHomeWork -
                  mastersIncomeOutcomeSum.outcomeHomeWork)
              }}
            </span>
            تومان
          </p>

        </div>


        <hr>

        <div>
          <h3 style="padding-bottom: 12px;">کلاس خصوصی</h3>

          <p>
            جمع <span class="text-success"> درآمد ناخالص کلاس خصوصی </span> فرمن:‌
            <span class="text-success">
              {{
                mastersIncomeOutcomeSum.incomeSchedule ?
                  Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeSchedule) : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="text-danger"> حقوق استاد از کلاس خصوصی </span>
            فرمن:
            <span class="text-danger">
              {{
                mastersIncomeOutcomeSum.outcomeSchedule
                  ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.outcomeSchedule)
                  : 0
              }}
            </span>
            تومان
          </p>
          <p>
            جمع
            <span class="ferman-orange-text-color">
              سود کسب شده از کلاس خصوصی
            </span>
            فرمن:
            <span class="ferman-orange-text-color">
              {{
                Intl.NumberFormat("en-US").format(mastersIncomeOutcomeSum.incomeSchedule -
                  mastersIncomeOutcomeSum.outcomeSchedule)
              }}
            </span>
            تومان
          </p>

        </div>
        <hr>

        <p>
          جمع <span class="text-success"> درآمد ناخالص </span> فرمن:‌
          <span class="text-success">
            {{
              fermanIncome ? Intl.NumberFormat("en-US").format(fermanIncome) : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="text-danger"> حقوق اساتید </span>
          فرمن:
          <span class="text-danger">
            {{
              fermanOutcome
                ? Intl.NumberFormat("en-US").format(fermanOutcome)
                : 0
            }}
          </span>
          تومان
        </p>

        <!-- DSD-651 -->

        <!-- <p>
          جمع
          <span class="ferman-cashbacks-text-color">
            وجوه بازگشتی (Cashback)
          </span>
          از ریفرال اساتید فرمن:
          <span class="ferman-cashbacks-text-color">
            {{
              totalCashbacks
                ? Intl.NumberFormat("en-US").format(totalCashbacks)
                : 0
            }}
          </span>
          تومان
        </p> -->
        <p>
          جمع
          <span class="text-primary"> سود کسب شده‌ی </span>
          فرمن:
          <span class="text-primary" dir="ltr" style="margin-left: 8px">
            {{ computedFermanProfit }}
          </span>
          تومان
        </p>
      </BCol>
    </template>
    <CustomTable :pageNumber="mastersIncomeOutcomeFilters.pageNumber" :count="mastersIncomeOutcomeFilters.count"
      :totalCount="totalCount" :tableColumns="myTableColumns" :tableItems="mastersIncomeOutcomeList"
      @changePage="changePage">
      <template #index="data">
        {{
          Math.ceil(
            data.index +
            1 +
            (mastersIncomeOutcomeFilters.pageNumber - 1) *
            mastersIncomeOutcomeFilters.count
          )
        }}
      </template>
      <template #fullName="data">
        <b-link :to="`/users/${data.item.userId}`">
          {{ data.item.fullName }}
        </b-link>
      </template>
      <template #outcome="data">
        <span class="text-danger">
          {{
            Intl.NumberFormat("en-US").format(
              data.item.outcome + data.item.cashback
            )
          }}
        </span>

        تومان
      </template>
      <template #income="data">
        <span class="text-success">
          {{ Intl.NumberFormat("en-US").format(data.item.income) }}
        </span>
        تومان
      </template>
      <template #netProfit="data">
        <span class="text-primary">
          {{
            Intl.NumberFormat("en-US").format(
              data.item.income - data.item.outcome
            )
          }}
        </span>
        تومان
      </template>
      <template #cashback="data">
        <span class="ferman-cashbacks-text-color">
          {{ Intl.NumberFormat("en-US").format(data.item.cashback) }}
        </span>
        تومان
      </template>
      <template #details="data">
        <BButton size="sm" variant="transparent" @click="getIncomeDetails(data)">
          <FeatherIcon class="text-info" icon="MapIcon" size="20" />
        </BButton>
      </template>
    </CustomTable>
    <MasterIncomeOutcomeModal :mastersIncomeOutcomeDetail="mastersIncomeOutcomeDetail"
      @closeModal="closeIncomeOutcomeModal"></MasterIncomeOutcomeModal>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getMastersIncomeOutcome();
  },
  data() {
    return {
      isLoading: false,
      mastersIncomeOutcomeFilters: {
        pageNumber: 1,
        count: 10,
        mobile: null,
        fullName: null,
        priceCategoryId: null,
        userId: null,
        fromDate: null,
        toDate: null,
        fromDateSchedule: null,
        toDateSchedule: null,
      },
      mastersIncomeOutcomeDetail: null,
      mastersIncomeOutcomeList: null,
      mastersIncomeOutcomeSum: null,
      fromToDateRange: null,
      fromToScheduleDateRange: null,
      totalCount: null,
      fermanIncome: null,
      fermanOutcome: null,
      fermanGroupClassIncome: null,
      totalCashbacks: null,
      totalIncomeFromHomeworks: null,
      myTableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "fullName",
          label: "نام استاد",
        },
        {
          key: "mobile",
          label: "شماره استاد",
        },
        {
          key: "outcome",
          label: "جمع حقوق",
        },

        // DSD-651

        // {
        //   key: "cashback",
        //   label: "وجوه بازگشتی از کد ریفرال",
        // },
        {
          key: "income",
          label: "درآمد ناخالص فرمن",
        },
        {
          key: "netProfit",
          label: "سود کسب شده‌ی فرمن",
        },
        {
          key: "details",
          label: "جزئیات",
        },
      ],
    };
  },
  methods: {
    closeIncomeOutcomeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("income-details-modal");
        this.mastersIncomeOutcomeDetail = null
      })
    },
    getIncomeDetails(data) {
      this.mastersIncomeOutcomeDetail = data
      this.$bvModal.show("income-details-modal");
    },
    setFromToDateRange(dateRange) {
      if (dateRange) {
        this.fromToDateRange = dateRange;
      } else {
        this.clearFromToDateRange();
      }
    },
    setFromToScheduleDateRange(dateRange) {
      if (dateRange) {
        this.fromToScheduleDateRange = dateRange;
      } else {
        this.clearFromToScheduleDateRange();
      }
    },
    changePage(pageNumber) {
      this.mastersIncomeOutcomeFilters.pageNumber = pageNumber;
      this.getMastersIncomeOutcome();
    },
    async getMastersIncomeOutcome() {
      try {
        this.calculateDates();
        this.isLoading = true;
        let _this = this;
        let getMasterIncomeOutcomeList = new GetMasterIncomeOutcomeList(_this);
        getMasterIncomeOutcomeList.setRequestParamDataObj(
          _this.mastersIncomeOutcomeFilters
        );
        await getMasterIncomeOutcomeList.fetch((res) => {
          _this.mastersIncomeOutcomeList = res.data;
          _this.mastersIncomeOutcomeSum = res
          _this.totalCount = res.total;
          _this.totalCashbacks = res.cashbacks;
          _this.fermanIncome = res.sum;
          _this.fermanOutcome = res.sum2;
          _this.fermanGroupClassIncome = res.groupClasses;
          if (res.homeWork) {
            _this.totalIncomeFromHomeworks =
              res.homeWork.masterHomeWorksInCome - res.homeWork.fermanInCome;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setPriceCategory(priceCategoryId) {
      this.mastersIncomeOutcomeFilters.priceCategoryId = priceCategoryId;
    },
    clearFromToDateRange() {
      this.fromToDateRange = null;
      this.mastersIncomeOutcomeFilters.fromDate = null;
      this.mastersIncomeOutcomeFilters.toDate = null;
    },
    clearFromToScheduleDateRange() {
      this.fromToScheduleDateRange = null;
      this.mastersIncomeOutcomeFilters.fromDateSchedule = null;
      this.mastersIncomeOutcomeFilters.toDateSchedule = null;
    },
    calculateDates() {
      if (this.fromToDateRange && this.fromToDateRange.length > 0) {
        this.mastersIncomeOutcomeFilters.fromDate = new Date(
          this.fromToDateRange?.[0]
        );
        this.mastersIncomeOutcomeFilters.toDate = new Date(
          this.fromToDateRange?.[1]
        );
      }
      if (
        this.fromToScheduleDateRange &&
        this.fromToScheduleDateRange.length > 0
      ) {
        this.mastersIncomeOutcomeFilters.fromDateSchedule = new Date(
          this.fromToScheduleDateRange?.[0]
        );
        this.mastersIncomeOutcomeFilters.toDateSchedule = new Date(
          this.fromToScheduleDateRange?.[1]
        );
      }
    },
  },
  computed: {
    computedFermanProfit() {
      if (this.fermanIncome >= 0 && this.fermanOutcome >= 0) {
        return Intl.NumberFormat("en-US").format(
          this.fermanIncome - this.fermanOutcome
        );
      } else {
        return 0;
      }
    },
  },
  components: {
    BCol,
    BLink,
    PriceCategoryPicker,
    PageWrapper,
    SearchInput,
    RangeDatePicker,
    CustomTable,
    BButton,
    MasterIncomeOutcomeModal,
  },
};
import { BCol, BLink, BButton } from "bootstrap-vue";
import MasterIncomeOutcomeModal from "@/views/components/Masters/MasterIncomeOutcomeModal.vue"
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetMasterIncomeOutcomeList } from "@/libs/Api/IncomeOutcomeTransaction";
</script>
<style scoped>
.ferman-cashbacks-text-color {
  color: #17a2b8;
}

.ferman-orange-text-color {
  color: #9c00bb;
}
</style>
